(function () {
	"use strict";

	const loadedAssets = new Set();

	function loadCss(href) {
		if (!href || loadedAssets.has(href) || document.querySelector(`link[href="${href}"]`)) {
			return;
		}

		const link = document.createElement("link");
		link.rel = "stylesheet";
		link.href = href;
		document.head.appendChild(link);
		loadedAssets.add(href);
	}

	function loadJs(src) {
		if (!src || loadedAssets.has(src) || document.querySelector(`script[src="${src}"]`)) {
			return;
		}

		const script = document.createElement("script");
		script.src = src;
		script.async = false;
		document.body.appendChild(script);
		loadedAssets.add(src);
	}

	// ── Shared image lightbox (scroll-zoom + drag-to-pan) ───────────────────────
	// The one canonical lightbox for every zoomable image across the bench,
	// from any app. Lives here (not in image_zoom_hover.js / image_click_zoom.js)
	// because this script is always loaded site-wide (web_include_js), while
	// those two are mutually exclusive and depend on the hover/click mode
	// toggle — a toggle that only makes sense for product images, not for
	// generic [data-zoom-enabled] images (e.g. Website HQ's Embed Card).
	// image_zoom_hover.js / image_click_zoom.js delegate their click-to-open
	// interaction here too, so there is exactly one lightbox implementation.
	let lbEl, lbImg, lbCaption, lbLastTrigger;
	let lbScale = 1, lbTx = 0, lbTy = 0;
	let lbDragging = false, lbPx = 0, lbPy = 0;

	function ensureLightbox() {
		if (lbEl) return;
		document.body.insertAdjacentHTML("beforeend",
			'<div class="rfhq-zoom-lightbox" data-no-anim role="dialog" aria-modal="true" aria-label="Image viewer">' +
				'<div class="rfhq-zoom-lb-backdrop"></div>' +
				'<button type="button" class="rfhq-zoom-lb-close" aria-label="Close">&times;</button>' +
				'<div class="rfhq-zoom-lb-stage"><img class="rfhq-zoom-lb-img" src="" alt="" draggable="false"></div>' +
				'<p class="rfhq-zoom-lb-caption"></p>' +
				'<div class="rfhq-zoom-lb-controls">' +
					'<button type="button" class="rfhq-zoom-lb-btn rfhq-zoom-lb-zoom-in" aria-label="Zoom in">+</button>' +
					'<button type="button" class="rfhq-zoom-lb-btn rfhq-zoom-lb-zoom-out" aria-label="Zoom out">&#8722;</button>' +
					'<button type="button" class="rfhq-zoom-lb-btn rfhq-zoom-lb-zoom-reset" aria-label="Reset zoom">&#8635;</button>' +
				'</div>' +
			'</div>'
		);

		lbEl = document.body.lastElementChild;
		lbImg = lbEl.querySelector(".rfhq-zoom-lb-img");
		lbCaption = lbEl.querySelector(".rfhq-zoom-lb-caption");

		lbEl.querySelector(".rfhq-zoom-lb-backdrop").addEventListener("click", closeLightbox);
		lbEl.querySelector(".rfhq-zoom-lb-close").addEventListener("click", closeLightbox);
		lbEl.querySelector(".rfhq-zoom-lb-zoom-in").addEventListener("click", function () { lbZoom(0.3); });
		lbEl.querySelector(".rfhq-zoom-lb-zoom-out").addEventListener("click", function () { lbZoom(-0.3); });
		lbEl.querySelector(".rfhq-zoom-lb-zoom-reset").addEventListener("click", lbReset);

		document.addEventListener("keydown", function (e) {
			if (!lbEl.classList.contains("is-open")) return;
			if (e.key === "Escape") closeLightbox();
			if (e.key === "+" || e.key === "=") lbZoom(0.3);
			if (e.key === "-") lbZoom(-0.3);
			if (e.key === "0") lbReset();
		});

		lbEl.addEventListener("wheel", function (e) {
			e.preventDefault();
			lbZoom(e.deltaY < 0 ? 0.2 : -0.2);
		}, { passive: false });

		lbImg.addEventListener("mousedown", function (e) {
			if (lbScale <= 1) return;
			e.preventDefault();
			lbDragging = true;
			lbPx = e.clientX; lbPy = e.clientY;
			lbImg.style.transition = "none";
		});
		window.addEventListener("mousemove", function (e) {
			if (!lbDragging) return;
			lbTx += e.clientX - lbPx;
			lbTy += e.clientY - lbPy;
			lbPx = e.clientX; lbPy = e.clientY;
			lbApplyTransform();
		});
		window.addEventListener("mouseup", function () {
			if (!lbDragging) return;
			lbDragging = false;
			lbImg.style.transition = "";
			lbImg.style.cursor = lbScale > 1 ? "grab" : "zoom-in";
		});
	}

	function lbZoom(delta) {
		lbScale = Math.min(5, Math.max(1, lbScale + delta));
		if (lbScale === 1) { lbTx = 0; lbTy = 0; }
		lbApplyTransform();
		lbImg.style.cursor = lbScale > 1 ? "grab" : "zoom-in";
	}

	function lbReset() {
		lbScale = 1; lbTx = 0; lbTy = 0;
		lbApplyTransform();
		if (lbImg) lbImg.style.cursor = "zoom-in";
	}

	function lbApplyTransform() {
		lbImg.style.transform = "translate(" + lbTx + "px," + lbTy + "px) scale(" + lbScale + ")";
	}

	function openLightbox(src, alt, caption, trigger) {
		if (!src) return;
		ensureLightbox();
		lbReset();
		lbImg.src = src;
		lbImg.alt = alt || caption || "";
		lbCaption.textContent = caption || "";
		lbCaption.style.display = caption ? "" : "none";
		lbLastTrigger = trigger || null;
		lbEl.classList.add("is-open");
		document.body.style.overflow = "hidden";
		lbEl.querySelector(".rfhq-zoom-lb-close").focus();
	}

	function closeLightbox() {
		if (!lbEl || !lbEl.classList.contains("is-open")) return;
		lbEl.classList.remove("is-open");
		document.body.style.overflow = "";
		lbImg.src = "";
		if (lbLastTrigger && typeof lbLastTrigger.focus === "function") lbLastTrigger.focus();
		lbLastTrigger = null;
	}

	window.rfhqImageLightbox = { open: openLightbox, close: closeLightbox };

	// ── [data-zoom-enabled]: app-agnostic "make this image zoomable" marker ───
	// Independent of the hover/click mode toggle below — any app can opt an
	// image into the lightbox just by adding this attribute, with no JS of
	// its own (mirrors animations.js's data-anim pattern).
	const ZOOM_ENABLED_SELECTOR = "[data-zoom-enabled]";

	function bindZoomEnabled(root) {
		(root || document).querySelectorAll(`${ZOOM_ENABLED_SELECTOR}:not([data-zoom-bound])`).forEach((target) => {
			const img = target.tagName === "IMG" ? target : target.querySelector("img");
			if (!img || !img.src) return;
			target.dataset.zoomBound = "true";
			target.style.cursor = "zoom-in";
			target.setAttribute("tabindex", "0");
			target.setAttribute("role", "button");
			target.setAttribute("aria-label", "Click to view larger image");

			const open = () => {
				// data-full-src (set by _shared.js's renderMedia for card images
				// that now carry srcset) always points at the untouched
				// original — currentSrc would be whichever smaller srcset
				// candidate got painted. See image_zoom_hover.js's fullResSrc
				// for the same fix, same reasoning.
				const fullSrc = (img.dataset && img.dataset.fullSrc) || img.currentSrc || img.src;
				openLightbox(fullSrc, img.alt, target.dataset.zoomCaption, target);
			};
			target.addEventListener("click", (e) => {
				e.preventDefault();
				open();
			});
			target.addEventListener("keydown", (e) => {
				if (e.key === "Enter" || e.key === " ") {
					e.preventDefault();
					open();
				}
			});
		});
	}

	// Requires window.rfhqDom (rfhq_dom_observer.js — always the first import
	// of websitehq.bundle.js). Never add a private MutationObserver here.
	function startZoomEnabledObserver() {
		bindZoomEnabled();

		window.rfhqDom.onAdded((roots) => {
			const isRelevant = roots.some(
				(node) => node.matches(ZOOM_ENABLED_SELECTOR) || node.querySelector(ZOOM_ENABLED_SELECTOR)
			);
			if (isRelevant) bindZoomEnabled();
		});
		// Consumers (e.g. rfhq_templates.js's Embed Card) often set
		// data-zoom-enabled on an <img> that already exists in the DOM
		// rather than inserting a new node — the added-nodes path would
		// miss that, so attribute changes count as relevant too.
		window.rfhqDom.onAttr(() => bindZoomEnabled());
	}

	// ── Product-image hover/click mode (lazy-loaded, mutually exclusive) ───────
	function loadConfiguredZoomAssets() {
		if (typeof frappe === "undefined" || typeof frappe.call !== "function") {
			return;
		}

		const targetSelector = ".product-image, .product-image img, .card-img-container, .list-image .website-image";
		const hasZoomTargets = () => Boolean(document.querySelector(targetSelector));

		const fetchZoomAssets = () => {
			frappe.call({
				method: "raftor_websitehq.utils.zoom_config.get_zoom_assets",
				callback: (response) => {
					const assets = response.message || {};
					loadCss(assets.css);
					loadJs(assets.js);
				},
			});
		};

		if (hasZoomTargets()) {
			fetchZoomAssets();
			return;
		}

		// Product/listing cards are often rendered client-side after an AJAX call
		// (e.g. webshop.ProductGrid), so keep watching instead of giving up after
		// a fixed number of attempts. Stop watching once assets are loaded, or
		// after a generous safety timeout so we don't watch pages with no images forever.
		const handler = () => {
			if (hasZoomTargets()) {
				window.rfhqDom.off(handler);
				fetchZoomAssets();
			}
		};
		window.rfhqDom.onAdded(handler);
		setTimeout(() => window.rfhqDom.off(handler), 30000);
	}

	function init() {
		startZoomEnabledObserver();
		loadConfiguredZoomAssets();
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
})();
